<template>
  <el-card header="新建">
    <el-form :model="articel"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="80px"
    >

      <el-form-item label="分类" prop="cate_id">
        <cate-option v-model="articel.cate_id"></cate-option>
      </el-form-item>
      <el-form-item label="title" prop="title">
        <el-input v-model="articel.title"></el-input>
      </el-form-item>
      <el-form-item label="content" prop="content">
        <!--<el-input v-model="articel.content"></el-input>-->
        <textarea id="content"></textarea>

      </el-form-item>
      <el-form-item label="desc" prop="desc">
        <el-input v-model="articel.desc"></el-input>
      </el-form-item>
      <el-form-item label="img" prop="img">
        <el-switch
          v-model="articel.img"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="articelCreate(articel)">创建</el-button>
        <el-button type="success" @click="backPage">返回</el-button>
      </el-form-item>

    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import back from '@/mixin/back'
  import CateOption from "../cate/CateOption";
  import config from "@/lib/http/config"

  export default {
    name: "ArticelCreate",
    mixins: [back],
    components: {
      CateOption
    },
    computed: {
      ...mapState({
        articel: state => state.articel.newArticel,
        rules: state => state.articel.rules,
        loading: state => state.articel.loading,
      }),
    },
    methods: {
      setContent(content) {
        CKEDITOR.instances.content.setData(content);
      },

      articelCreate(articel) {
        let vthis = this;
        this.$refs['ruleForm'].validate(validate => {
          if (!validate) {
            return;
          }
          this.content = CKEDITOR.instances.content.getData();
          articel.content = content;
          this.$store.dispatch('articel/create', articel).then((res) => {
            vthis.$confirm('是否关闭此页面').then(_ => {
              vthis.$router.go(-1);
            }).catch(_ => {
            });
          })
        });
      }
    },
    mounted() {
      CKEDITOR.replace('content', {
        filebrowserImageUploadUrl: config.baseURL + '/api/ck/upload',
        language: 'zh-cn',
        height: 600,
      });
      this.setContent("<p>asdfasdf</p>");
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/articel/ArticelCreate.vue